module.exports = __webpack_public_path__ + "static/img/icon-search.ecf5a446.svg";